import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';

export function normalizeTaxCodeForUniqueCheck(raw: string): string {
  return raw.replace(/\D/g, '');
}

function parseIsUniqueResponse(data: unknown): boolean | null {
  if (data === true || data === false) return data;
  if (typeof data !== 'object' || data === null) return null;
  const o = data as Record<string, unknown>;
  const v =
    o.value ??
    o.Value ??
    o.isUnique ??
    o.IsUnique ??
    o.data ??
    o.result ??
    o.Result;
  if (typeof v === 'boolean') return v;
  if (typeof v === 'number') return v !== 0;
  if (typeof v === 'string') return /^true$/i.test(v.trim()) || v.trim() === '1';
  return null;
}

export async function checkTaxCodeIsUnique(
  taxCodeDigits: string,
  excludedBandId?: number | null
): Promise<boolean> {
  const normalized = normalizeTaxCodeForUniqueCheck(taxCodeDigits);
  const localApi = await getLocalApi();
  const template = (apiConfig as Record<string, string>).tax_rules_tax_code_is_unique;
  if (!template) {
    throw new Error('tax_rules_tax_code_is_unique is not configured in apiConfig');
  }
  let url = template.replace('{taxCode}', encodeURIComponent(normalized));
  if (excludedBandId != null && excludedBandId > 0) {
    url += `${url.includes('?') ? '&' : '?'}excludedBandId=${encodeURIComponent(String(excludedBandId))}`;
  }

  const data = await localApi.fetchSingle<unknown>(
    url.replace(/^\/+/, ''),
    (x) => x,
    'Unable to verify tax code uniqueness'
  );
  const parsed = parseIsUniqueResponse(data);
  if (parsed === null) {
    throw new Error('Unexpected uniqueness response from server');
  }
  return parsed;
}